import { combineSlices } from '@reduxjs/toolkit';

import { experimentsReducer, variantsReducer } from 'wanderu-analytics';
import {
    reducer as browserMetaReducer,
    namespace as browserMetaNamespace,
} from 'wanderu-ducks-browser-meta';
import carrierReducerMap from 'wanderu-ducks-carriers';
import googleReducerMap from 'wanderu-ducks-google';
import interlinkReducerMap from 'wanderu-ducks-interlink';
import partnerReducerMap from 'wanderu-ducks-partner-data';
import pricingReducerMap from 'wanderu-ducks-pricing';
import splitTestReducerMap from 'wanderu-ducks-split-test';
import stationsReducerMap from 'wanderu-ducks-stations';
import tripsReducerMap from 'wanderu-ducks-trips';
import widgetReducerMap from 'wanderu-ducks-widget';
import { i18nReducer } from 'wanderu-i18n';

const rootReducer = combineSlices({
    ...interlinkReducerMap,
    ...pricingReducerMap,
    ...carrierReducerMap,
    ...tripsReducerMap,
    ...stationsReducerMap,
    ...googleReducerMap,
    ...partnerReducerMap,
    [browserMetaNamespace]: browserMetaReducer,
    i18n: i18nReducer,
    ...splitTestReducerMap,
    ...widgetReducerMap,
    'DUCKS/ACCOUNT': (state) => state || {},
    'DUCKS/AIRPORT_SHUTTLES_GUIDES': (state) => state || {},
    'DUCKS/BOOKING': (state) => state || {},
    'DUCKS/HOMEPAGE': (state) => state || {},
    'DUCKS/LIVE_CHECK': (state) => state || {},
    'DUCKS/PRODUCT_REVIEW': (state) => state || {},
    'DUCKS/PSEARCH': (state) => state || {},
    'DUCKS/SEARCH': (state) => state || {},
    'DUCKS/SEO': (state) => state || {},
    'DUCKS/STATION_GUIDES': (state) => state || {},
    'DUCKS/TERMS_AND_CONDITIONS': (state) => state || {},
    detailedPricing: (state) => state || {},
    discount: (state) => state || {},
    experiments: experimentsReducer,
    orders: (state) => state || {},
    variants: variantsReducer,
}).withLazyLoadedSlices();

export default rootReducer;
